export const CUSTOM_FIELD_CATEGORIES = {
  CASE: "case",
  EVIDENCE: "evidence",
  ACQUISITION: "acquisition",
  INQUIRY: "inquiry",
  STORAGE: "storage",
  PEOPLE: "people",
  ASSET: "asset",
};
